import React from 'react';
import { Table, Button } from 'reactstrap';
import Row from '../Row';
import $, { data } from 'jquery';
import DropZoneTable from './DropZoneTable';
import {connect} from 'react-redux'
import UpArrow from '@mui/icons-material/KeyboardArrowUp';
import DownArrow from '@mui/icons-material/KeyboardArrowDown';

class PrinterConnectionsTable extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            currentPage: 0,
            numPages: 0,
            pageLimit: 10,
            rowsShown: 9,
            sortConfig: { key: null, direction: 'asc' },
            ...props,
            filters: {
                name: '',
                address: '',
                protocol: '',
                state: '',
                date: ''
            },
            showFilters: false
        }

        this.goToNextPage = this.goToNextPage.bind(this)
        this.goToPrevPage = this.goToPrevPage.bind(this)
    }

    componentDidUpdate(prevProps) {  
        if(this.props.logs.length !== prevProps.logs.length){
            let noPages = Math.ceil(this.props.logs.length / this.state.pageLimit)
            this.setState({
                numPages: noPages,
                currentPage: 0
            })
        }
    }

    handleFilterChange = (key, value) => {
    this.setState((prevState) => ({
        filters: {
            ...prevState.filters,
            [key]: value
        },
        currentPage: 0 // optional: reset to first page on filter
        }));
    };

    toggleFilters = () => {
        this.setState((prevState) => ({
            showFilters: !prevState.showFilters
        }));
    };

    clearAllFilters = () => {
        this.setState({
            filters: {
            name: '',
            address: '',
            protocol: '',
            state: '',
            date: ''
            },
            currentPage: 0 // optional: reset to first page
        });
    };

    goToNextPage() {
        let page = this.state.currentPage+1
        if(page<this.state.numPages)
            this.setState({
                currentPage:page
            })
      }
    
    goToPrevPage() {
    let page = this.state.currentPage-1
    if(page>=0)
        this.setState({
            currentPage:page
        })
    }

    onSort = (key) => {
        this.setState((prevState) => {
            const direction = prevState.sortConfig.key === key && prevState.sortConfig.direction === 'asc' ? 'desc' : 'asc';

            const logs = this.state.logs ?? this.props.logs ?? [];

            const sortedLogs = [...logs].sort((a, b) => {
                let aValue = a[key];
                let bValue = b[key];

                if (key === 'Date') {
                    aValue = new Date(aValue);
                    bValue = new Date(bValue);
                }

                if (aValue == null) aValue = '';
                if (bValue == null) bValue = '';

                if (typeof aValue === 'string') aValue = aValue.toLowerCase();
                if (typeof bValue === 'string') bValue = bValue.toLowerCase();

                if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                return 0;
            });

            return {
                logs: sortedLogs,
                sortConfig: { key, direction }                
            };
        });
    };

    renderSortableFilterableHeader = (filterKey, onSort, sortConfigKey, labelKey, labelFallback) => {
      const isSorted = this.state.sortConfig.key === sortConfigKey;
      const sortArrow = isSorted
      ? this.state.sortConfig.direction === 'asc'
        ? <UpArrow />
        : <DownArrow />
      : null;

      const label = this.getLocalizedLabel(labelKey, labelFallback);

      return (
      <th
        key={filterKey}
        className="s-grid-title-cell"
        style={{ cursor: 'pointer' }}
        onClick={() => this.onSort(onSort)}
      >
        <div className="s-grid-title-cell-filter">
          {label} {sortArrow}
        </div>
        <div>
          {this.state.showFilters && (
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder="Start typing to search..."
              value={this.state.filters[filterKey] || ''}
              onMouseDown={(e) => e.stopPropagation()}
              onChange={(e) => this.handleFilterChange(filterKey, e.target.value)}
            />
          )}
        </div>
      </th>
      );
    };

    getLocalizedLabel = (key, fallback) => {
      const labelObj = this.props.userReducer.localisation[key];
      return labelObj?.element_lang || fallback;
    };



    render() {

        var b = true
        let grid_css = ''
        let id
        let rows = []
        let pageignation = <div />

        const { localisation } = this.props.userReducer;

        const filtersActive = Object.values(this.state.filters).some(
            val => val.trim() !== ''
        );

        let startItem = (this.state.currentPage * this.state.rowsShown) + this.state.currentPage;
        let endItem = startItem + this.state.rowsShown;

        let logsToRender = (this.state.logs.length ? this.state.logs : this.props.logs).filter(file => {
            const { filters } = this.state;

            const matches = (field, value) =>
                field?.toString().toLowerCase().includes(value.toLowerCase());

            const extractDatePortion = (dateStr) => {
                if (!dateStr) return '';
                const date = new Date(dateStr);

                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const year = String(date.getFullYear()).slice(2); // Get last 2 digits of year

                return `${day}/${month}/${year}`; // e.g. "03/04/25"
            };


            const userInput = filters.date.trim();
            const matchDate = userInput
                ? extractDatePortion(file.Date).includes(userInput)
                : true;

            return (
                matches(file.Name, filters.name) &&
                matches(file.RemoteAddress + ":" + file.RemotePort, filters.address) &&
                matches(file.RemoteProtocol, filters.protocol) &&
                matches(file.State, filters.state) &&
                matchDate
            );

        });

        if (logsToRender){
            logsToRender.forEach((row, i) => {
                const is_checked = (this.props.checkedlogs || []).some(x => x._id === row._id);
                if (!this.props.nopages) {
                if (i < startItem)
                    return
                if (i > endItem)
                    return
            }

            if (b)
                grid_css = "s-grid-row"
            else
                grid_css = "s-grid-row s-record-alt"
                b = !b
                if (this.props.keyid !== undefined && this.props.keyid === i)
                    grid_css += " dotted-row"

                id = "P" + row._id

                rows.push(
                    <Row
                        rightAlign={[5]}
                        viewPortfolio={false}
                        onRowClicked={() => this.props.rowClicked(row.Name)}
                        is_checked={is_checked}
                        checked={this.props.checked}
                        i={i}
                        checkChange={this.props.checkChange}
                        refresh={this.props.refresh}
                        id={id}
                        fileid={row._id}
                        tr_css={grid_css}
                        filename={row.Name}
                        filetype={row.RemoteAddress + ":" + row.RemotePort}
                        version={row.RemoteProtocol}
                        dated={row.Date}
                        user={row.State}
                        file={row}
                        pages={1}
                        columnConfig={this.props.columnConfig}
                    />
                );
            });
        }

        if(this.props.logs) {
            pageignation =  <div>
                <div class="s-array-topbar-right">
                    <label class="s-pager-range">{this.props.logs.length > 1 ? localisation['table_header_records'] ? this.props.logs.length + ' ' + localisation['table_header_records'].element_lang : '' : localisation['table_header_record'] ? this.props.logs.length + ' ' + localisation['table_header_record'].element_lang : '' }</label>
                    <label class="s-pager-range">|</label>
                    <label class="s-pager-size-label">Page {this.state.currentPage+1} / {this.state.numPages}</label>
                    <div class="s-pager">
                        <a onClick={this.goToPrevPage} class="s-pager-link s-fonticon-btn s-btn-previous"></a>
                        <a onClick={this.goToNextPage} class="s-pager-link s-fonticon-btn s-btn-next"></a>
                    </div>
                    <a onClick={this.props.refresh} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                    <button
                        className="btn btn-sm btn-outline-secondary"
                        style={{ marginLeft: '10px' }}
                        onClick={this.toggleFilters}
                        title={this.state.showFilters ? 'Hide search filters' : 'Show search filters'}
                    >
                        <i className="fa fa-filter" aria-hidden="true"></i>
                        <span style={{ marginLeft: '5px' }}>
                        {this.state.showFilters ? 'Hide search Filters' : 'Show search Filters'}
                        </span>
                    </button>
                    {filtersActive && (
                        <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={this.clearAllFilters}
                            title="Clear all filter fields"
                            style={{ marginLeft: '10px' }}
                        >
                            <i className="fa fa-times" aria-hidden="true" style={{ marginRight: '5px' }}></i>
                            Clear Filters
                        </button>
                    )}
                </div>
                <div class="s-array-topbar-left">
                    <a onClick={this.props.selectAll} class="s-mn-list-btn s-pager-link s-fonticon-btn s-mn-link s-btn-refresh"></a>
                </div>
            </div>
        }


        return(
            <div class="s-slot-row">
                {pageignation}
                <Table responsive={true} hover={true} className="s-grid-table-head">
                    <tr>
                        {this.props.columnConfig?.checkbox && (
                            <th className="s-grid-title-cell s-grid-title-cell-small">
                                <div className="s-grid-title-empty"></div>
                            </th>
                        )}
                        {/* filterKey, onSort, sortConfigKey, labelKey, labelFallback */}
                        {this.renderSortableFilterableHeader('name', 'Name', "Name", "table_header_name", "Name")}
                        {this.renderSortableFilterableHeader('address', 'Address', "Address", "table_header_address", "Address")}
                        {this.renderSortableFilterableHeader('protocol', 'Protocol', "Protocol", "table_header_protocol", "Protocol")}
                        {this.renderSortableFilterableHeader('state', 'State', "State", "table_header_state", "State")}
                        {this.renderSortableFilterableHeader('date', 'Date', "Date", "table_header_date", "Date")}
                    </tr>
                </Table>
                <div class="s-grid-slot-body">
                    <DropZoneTable refresh={this.props.refresh} rows={rows} />
                </div> 
            </div>
        );
    }
}

export default connect(state => state)(PrinterConnectionsTable);
